(function () {
  'use strict';

  var whatsappMessage = "Hello Florix Sports, I'd like to discuss a custom apparel manufacturing project.";

  function updateText(selector, from, to) {
    document.querySelectorAll(selector).forEach(function (element) {
      if (element.textContent.trim() === from) element.textContent = to;
    });
  }

  function addFooterSeal(container, label) {
    if (!container || container.querySelector('[data-phase4-seal="' + label + '"]')) return;
    var seal = document.createElement('div');
    seal.className = 'footer-seal';
    seal.dataset.phase4Seal = label;

    var check = document.createElement('span');
    check.className = 'footer-seal-check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = '✓';

    var text = document.createElement('span');
    text.className = 'footer-seal-label';
    text.textContent = label;

    seal.appendChild(check);
    seal.appendChild(text);
    container.appendChild(seal);
  }

  function initialise() {
    document.querySelectorAll('.db-nav__item-desc').forEach(function (element) {
      if (element.textContent.trim() === 'Pre-production samples in 7–14 days') {
        element.textContent = 'Sample development and approval guidance';
      }
    });

    updateText('.db-nav__item-label, .db-nav__mobile-sub a', 'Blog & Resources', 'Resources & Guides');
    updateText('.db-nav__item-label, .db-nav__mobile-sub a, .footer-link', 'Portfolio', 'Capabilities');

    document.querySelectorAll('.cat-trust-pill').forEach(function (element) {
      var text = element.textContent.trim();
      if (text.indexOf('3–5 Week Production') !== -1) {
        element.textContent = '⏱ Timelines confirmed by specification';
      }
      if (text.indexOf('Factory-Direct Pricing') !== -1) {
        element.textContent = '🏷 Specification-Based Pricing';
      }
    });

    document.querySelectorAll('a[href^="https://wa.me/447551311862"]').forEach(function (link) {
      if (link.href.indexOf('text=') === -1) {
        link.href = 'https://wa.me/447551311862?text=' + encodeURIComponent(whatsappMessage);
      }
      link.setAttribute('aria-label', 'Discuss a custom apparel manufacturing project with Florix Sports on WhatsApp');
    });

    var footerTagline = document.querySelector('.footer-tagline');
    if (footerTagline && footerTagline.textContent.indexOf('factory-direct pricing') !== -1) {
      footerTagline.textContent = 'Custom apparel development, low MOQ production, private labels and worldwide delivery.';
    }

    var trustLabel = document.querySelector('.footer-trust-label');
    if (trustLabel) trustLabel.textContent = 'Manufacturing Order Process';

    document.querySelectorAll('.footer-payment-icon-wrap').forEach(function (icon) {
      icon.remove();
    });

    var seals = document.querySelector('.footer-trust-seals');
    addFooterSeal(seals, '40/60 Bulk Terms');
    addFooterSeal(seals, 'Tracked Delivery Available');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();
